module.exports = __webpack_public_path__ + "img/seller_live posts.02ee6193.svg";